<template>
  <div id="makeSurePas">
    <div class="top"><img src="../../assets/img/logo2.png" alt="" /></div>
    <div class="content">
      <div class="dialog-title">{{ dialogData.title }}</div>
      <div class="goBack" @click="handleClick(dialogData.goBack.active)">
        <i class="el-icon-d-arrow-left"></i>
        {{ dialogData.goBack.btnName }}
      </div>
      <!-- 申请状态:验证身份,重置密码 -->
      <div class="verification">
        <div class="verification_outer">
          <div class="ver3"></div>
          <div class="ver1">
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
            <div class="ver1_center"></div>
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
          </div>
          <div class="ver2">
            <span>验证身份</span>
            <span>重置密码</span>
          </div>
        </div>
      </div>
      <div class="dialog-content customScrollBar">
        <div class="line" v-for="(item, index) in dialogData.data" :key="index">
          <div class="title">
            {{ item.name }}<span v-if="!item.isNull">*</span>
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              show-password
            ></el-input>
          </div>
        </div>
        <div class="dialog-but">
          <div class="title"></div>
          <div class="valuebtn" @click="reset">
            <span>{{ dialogData.btnName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "makeSurePas",
  props: {
    makeSurePasData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "",
          data: [],
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.makeSurePasData,
    };
  },
  methods: {
    handleClick(active) {
      this.$emit("handleClick", active);
    },
    reset() {
      this.$emit("reset");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#makeSurePas {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-around;
  .top {
    width: 25rem;
    height: 5rem;
    box-sizing: border-box;
    margin: 10px 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    border-radius: 10px;
    width: 75rem;
    height: 70%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    position: relative;

    .dialog-title {
      width: 80%;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      font-weight: 700;
      border-bottom: 1px solid rgba(204, 204, 204, 1);
    }
    .goBack {
      position: absolute;
      left: 15px;
      top: 15px;
      font-size: 15px;
      &:hover {
        cursor: pointer;
      }
    }
    .verification {
      width: 100%;
      height: 3.75rem;
      display: flex;
      justify-content: center;
      margin: 20px 0;
      .verification_outer {
        width: 72%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-end;

        .ver1 {
          width: 84%;
          display: flex;
          align-items: center;
          margin-right: 17px;
          .ver1_l {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: rgba(152, 188, 255, 1);
            display: flex;
            justify-content: center;
            align-items: center;

            .ver1_l_c {
              width: 9px;
              height: 9px;
              border-radius: 50%;
              background: rgba(51, 125, 255, 1);
            }
          }
          .ver1_center {
            flex: 1;
            height: 8px;
            background: rgba(224, 241, 255, 1);
          }
        }
        .ver2 {
          width: 88%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .dialog-content {
      width: 100%;
      height: 90%;
      box-sizing: border-box;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .line {
        width: 70%;
        height: 2.625rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 10px;
        .title {
          font-size: 14px;
          margin-right: 30px;
          > span {
            color: red;
          }
        }
        .value {
          width: 86%;
          height: 43px;
          position: relative;
          .yzm {
            position: absolute;
            right: 10px;
            top: 12px;
            color: rgba(0, 79, 148, 1);
            font-size: 14px;
            font-weight: 400;
            &:hover {
              cursor: pointer;
              color: rgb(7, 132, 241);
            }
          }
        }
      }
      .dialog-but {
        width: 70%;
        height: 2.8125rem;
        box-sizing: border-box;
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        margin-top: 50px;
        .valuebtn {
          width: 86%;
          height: 43px;
          background: rgba(7, 80, 139, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          &:hover {
            cursor: pointer;
          }
          > span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
